import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmailPreviewHydrationData } from '@galaxy/email-ui/email-builder';
import { TranslateService } from '@ngx-translate/core';
import { ProjectionFilter } from '@vendasta/account-group';
import { DialogData } from '@vendasta/businesses';
import { firstValueFrom, map, Observable } from 'rxjs';
import {
  ContactData,
  ContactSelectorComponent,
} from '@galaxy/email-ui/email-builder/src/components/preview-context-selector/contact-selector-modal/contact-selector.component';
import { Sender } from '@vendasta/email';
import { SENDER_INJECTION_TOKEN } from '@galaxy/email-ui/email-builder/src/shared';

export type Layout = 'vertical' | 'horizontal';

@Component({
  selector: 'app-preview-contact-selector',
  templateUrl: './preview-contact-selector.component.html',
  styleUrls: ['./preview-contact-selector.component.scss'],
})
export class PreviewContactSelectorComponent {
  name: string;
  showWarning$: Observable<boolean>;
  warningKey$?: string;
  dialogData?: DialogData;

  @Input() set hydrationData(v: EmailPreviewHydrationData) {
    this.dialogData = {
      partnerId: v?.partnerID,
      marketId: v?.marketID,
      projectionFilterOverride: {
        napData: true,
        accountGroupExternalIdentifiers: true,
        snapshotReports: true,
      } as ProjectionFilter,
    };
  }

  @Input() layout: Layout = 'horizontal';

  @Output() contactSelected = new EventEmitter<string>();

  constructor(
    private readonly translate: TranslateService,
    private readonly dialog: MatDialog,
    @Inject(SENDER_INJECTION_TOKEN) private readonly sender$: Observable<Sender>,
  ) {}

  async openSelectDialog(): Promise<void> {
    return this.openContactSelectDialog();
  }

  async openContactSelectDialog(): Promise<void> {
    const dialog = this.dialog.open(ContactSelectorComponent, {
      data: this.sender$.pipe(map((sender) => ({ accountGroupID: sender.id }))),
      minWidth: '350px',
    });
    const contact: ContactData = await firstValueFrom(dialog.afterClosed());
    if (contact) {
      this.name = contact.name;
      this.contactSelected.emit(contact.contactID);
    }
  }
}
